export const INITIAL_FORM_STATE = {
  decisionNote: '',
};
